class SectionTwo {
  constructor () {
    this.$android = $('#sectionTwo .android')
    this.$iphone = $('#sectionTwo .iphone')
    this.$accordionItems = $('#sectionTwo .accordionBox--item')
    this.$mobileBox = $('#sectionTwo .cellPhoneBoxMobile')
    
    this.init()
  }
  
  init () {
    //  处理手风琴
    this._accordionItemsHandler()
    //  默认第一个选中
    this.$accordionItems.eq(0).click()
    
    //  添加移动端轮播
    if (window.innerWidth < 768) {
      this._mobileSlickHtmlInit()
      this._mobileSlickCall()
    }
  }
  
  
  /**
   * 处理移动端手机轮播
   * @private
   */
  _mobileSlickCall () {
    let oSlickTarget = this.$mobileBox.find('.iphoneVideo')
    oSlickTarget.on('init', () => {
      let firstVideo = oSlickTarget.find('video').eq(0)
      firstVideo.attr('src', firstVideo.data('src'))
    })
    oSlickTarget.on('beforeChange', (ev, slick, current, next) => {
      let video = oSlickTarget.find('video').eq(next)
      video.attr('src', video.data('src'))
    })
    oSlickTarget.slick({
      fade: false,
      swipe: true,
      dots: true,
      waitForAnimate: false, //  不等待animate执行结束
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      cssEase: 'ease-out',
      slidesToScroll: 1,
      adaptiveHeight: false,//  自动高度取消
      edgeFriction: 0,//  自动高度取消
    })
  }
  
  /**
   * 处理移动端手机轮播html初始化
   * @private
   */
  _mobileSlickHtmlInit () {
    let html = ''
    this.$accordionItems.map((key, el) => {
      let poster = el.dataset.iphone.replace('.mp4', '.jpg')
      if (window.isSamsungBrowser) {
        html += `<img src="${poster}" />`
      } else {
        html += `<video controls muted="1" autoplay loop="1" poster="${poster}" data-setup="{}" data-src="${el.dataset.iphone}?random=${window.randomString}"></video>`
      }
    })
    this.$mobileBox.html(`<div class="iphone"><div class="iphoneVideo">${html}</div></div>`)
  }
  
  /**
   * 手风琴效果处理
   * @private
   */
  _accordionItemsHandler () {
    this.$accordionItems.on('click', ev => {
      let target = ev.currentTarget
      let iphone = target.dataset.iphone
      let android = target.dataset.android
      
      $(target).addClass('active').siblings().removeClass('active')
      this.$iphone.html(`<div class="iphoneVideo"><video preload="auto" autoplay muted loop playsinline data-setup="{}" src="${iphone}?random=${window.randomString}"></video></div>`)
      this.$android.html(`<img src="${android}?random=${window.randomString}" class="android--image" />`)
    })
  }
  
}

export default SectionTwo
